import React, { useState, useImperativeHandle, forwardRef } from "react";
import * as PropTypes from "prop-types";
import { Button, Modal, Radio } from "antd";

const filtersClean = {
	ativo     : null,
	created_at: null,
};

const Filters = forwardRef(({ visible, onComplete, onClose }, ref) => {
	const [filters, setFilters] = useState({ ...filtersClean });

	useImperativeHandle(ref, () => ({
		onOpen: (filters) => {
			setFilters(filters);
		},
	}));

	const cleanFilters = () => {
		setFilters(filtersClean);
		onComplete({ ...filtersClean });
	};

	const filtersOnConfirm = () => {
		onComplete({ ...filters });
	};

	const setFilter = (name, value) => {
		setFilters(prev => ({
			...prev,
			[name]: value,
		}));
	};

	return (
		<Modal
			visible={visible}
			title="Filtrar"
			centered={true}
			destroyOnClose={true}
			maskClosable={true}
			width={900}
			okText="Aplicar"
			onCancel={onClose}
			onOk={filtersOnConfirm}
			className="modal-filters"
			footer={[
				<Button key="back" type="link" onClick={cleanFilters}>Excluir filtros</Button>,
				<Button key="submit" type="primary" onClick={filtersOnConfirm}>Aplicar</Button>,
			]}>
			<div className="filter-group">
				<div className="filter-group-title" style={{ paddingTop: 0 }}>
					<h3>Status</h3>
				</div>
				<div className="filter-group-filters" style={{ paddingBottom: 5 }}>
					<div className="filter-group-radios">
						<div className="filter-group-radio">
							<Radio onChange={() => setFilter("ativo", null)} checked={filters.ativo === null}>Todos</Radio>
						</div>
						<div className="filter-group-radio">
							<Radio onChange={() => setFilter("ativo", 1)} checked={filters.ativo === 1}>Ativo</Radio>
						</div>
						<div className="filter-group-radio">
							<Radio onChange={() => setFilter("ativo", 0)} checked={filters.ativo === 0}>Inativo</Radio>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
});

Filters.propTypes = {
	visible   : PropTypes.bool.isRequired,
	onComplete: PropTypes.func.isRequired,
	onClose   : PropTypes.func.isRequired,
};

export default Filters;